import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { Pagination } from "../../../components/Pagination";

import { tableHeaderReportCards } from "../../../assets/utils/arrays";
import { reverseDateForTable } from "../../../assets/utils/functions";

export const ReportCardTable = () => {
  const allReportCards = useSelector((state) => state.reportCards.reportCards);
  const isMobile = useMediaQuery({ maxWidth: 520 });

  const numberOfRecords = isMobile ? 5 : 10;
  const [currentPage, setCurrentPage] = useState(1);

  const lastRecordIndex = currentPage * numberOfRecords;
  const firstRecordIndex = lastRecordIndex - numberOfRecords;
  const currentRecords = allReportCards?.grades?.slice(
    firstRecordIndex,
    lastRecordIndex
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="schedule-table-block">
        <table className="schedule-table">
          <thead className="table-header">
            <tr className="table-header_row">
              {tableHeaderReportCards.map((name, index) => (
                <th className="table-header_item" key={index}>
                  {name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRecords?.map((item, index) => (
              <tr key={index} className="table-body_row_item">
                <td className="table-body_row_item">{item.examType}</td>
                <td className="table-body_row_item">{item.disciplineName}</td>
                <td className="table-body_row_item lesson_number">
                  {item.grade === "неизвестно" ? "▬" : item.grade}
                </td>
                <td className="table-body_row_item lesson_number">
                  {item.hours === null ? "▬" : item.hours}
                </td>
                <td className="table-body_row_item lesson_number">
                  {item.testPoints === null ? "▬" : item.testPoints}
                </td>
                <td className="table-body_row_item">
                  {item.teachers.length !== 0 ? item.teachers.join(",") : "▬"}
                </td>
                <td className="table-body_row_item">
                  {item.grade === "неизвестно"
                    ? "▬"
                    : reverseDateForTable(item.dateOfExam)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mobile-statistic">
        {currentRecords?.map((item, index) => (
          <div key={index} className="cart-item">
            <h3 className="cart-item-header">{item.disciplineName}</h3>
            <div className="cart-item-row">
              <span className="cart-span">Отметка:</span>
              {item.grade === "неизвестно" ? "▬" : item.grade}
            </div>
            <div className="cart-item-row">
              <span className="cart-span">Форма контроля:</span>
              {item.examType === null ? "▬" : item.examType}
            </div>
            <div className="cart-item-row">
              <span className="cart-span">Кол-во часов:</span>
              {item.hours === null ? "▬" : item.hours}
            </div>
            <div className="cart-item-row">
              <span className="cart-span">Кол-во зачётных единиц:</span>
              {item.testPoints === null ? "▬" : item.testPoints}
            </div>
            <div className="cart-item-row">
              <span className="cart-span">ФИО преподавателя:</span>
              {item.teachers.length !== 0 ? item.teachers.join(",") : "▬"}
            </div>
            <div className="cart-item-row">
              <span className="cart-span">Дата:</span>
              {item.grade === "неизвестно"
                ? "▬"
                : reverseDateForTable(item.dateOfExam)}
            </div>
          </div>
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        numberOfRecords={numberOfRecords}
        totalRecords={allReportCards?.grades?.length}
        onPageChange={handlePageChange}
      />
    </>
  );
};
